import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BroadcastService {

  private messageSource = new BehaviorSubject<string>("");
  currentMessage = this.messageSource.asObservable();

  constructor() { }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  emit(message: string) {
    this.messageSource.next(message);
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/broadcast/broadcast.service.ts